__turbopack_context__.v({
  "boldText": "LNrYxG_boldText",
  "closeButton": "LNrYxG_closeButton",
  "container": "LNrYxG_container",
  "ctaButton": "LNrYxG_ctaButton",
  "description": "LNrYxG_description",
  "headline": "LNrYxG_headline",
  "imageContainer": "LNrYxG_imageContainer",
  "textContainer": "LNrYxG_textContainer",
});
